import UserEditor from './UserEditor.vue';

export default UserEditor;
